export default __webpack_public_path__ + "static/media/Group1278Tata.af98ab2f.png";